<template>
<div>
    <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab>Locations</v-tab>
        <v-tab>Networks</v-tab>
        <v-tab>Nodes</v-tab>
        <v-tab>Switching Centres</v-tab>
    </v-tabs>
    <div v-if="tab==0">
        <Locations />
    </div>
    <div v-if="tab==1">
        <LocationNetwork />
    </div>
    <div v-if="tab==2">
        <LocationNode />
    </div>
    <div v-if="tab==3">
        <SwitchingCentre />
    </div>
</div>
</template>

<script>
import LocationNode from './LocationNode.vue'
import LocationNetwork from './LocationNetwork.vue'
import SwitchingCentre from './SwitchingCentre.vue'
import Locations from './locations.vue'

export default {
    components: {
        Locations,
        LocationNode,
        LocationNetwork,
        SwitchingCentre
    },
    data() {
        return {
            tab: 0
        }
    }
}
</script>
